import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';

var IlIcon = /*#__PURE__*/function (_Component) {
  _inherits(IlIcon, _Component);
  var _super = _createSuper(IlIcon);
  function IlIcon() {
    _classCallCheck(this, IlIcon);
    return _super.apply(this, arguments);
  }
  _createClass(IlIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        className = _this$props.className,
        size = _this$props.size,
        onClickIcon = _this$props.onClickIcon;
      var xlinkHref = "#icon--".concat(name);
      var iconClassName = className || 'il-framework-component__il-icon';
      return (
        /*#__PURE__*/
        // focusable="false" prevents buggy tab sequencing of SVG elements in IE11
        React__default.createElement("svg", {
          onClick: onClickIcon,
          height: size,
          width: size,
          className: iconClassName,
          focusable: "false"
        }, /*#__PURE__*/React__default.createElement("use", {
          xlinkHref: xlinkHref
        }))
      );
    }
  }]);
  return IlIcon;
}(Component);
IlIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.number,
  onClickIcon: PropTypes.func
};

export { IlIcon };
